import { render, staticRenderFns } from "./DetalleVODForm.vue?vue&type=template&id=5aac5336&scoped=true&"
import script from "./DetalleVODForm.vue?vue&type=script&lang=ts&"
export * from "./DetalleVODForm.vue?vue&type=script&lang=ts&"
import style0 from "./DetalleVODForm.vue?vue&type=style&index=0&id=5aac5336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac5336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5aac5336', component.options)
    } else {
      api.reload('5aac5336', component.options)
    }
    module.hot.accept("./DetalleVODForm.vue?vue&type=template&id=5aac5336&scoped=true&", function () {
      api.rerender('5aac5336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/VOD/DetalleVODForm.vue"
export default component.exports